import Vue from 'vue';
import moment from 'moment';
import {generateLuhnForIccid} from '@/helpers/luhn';

Vue.filter('formatDate', (date: Date | string | number, includeSeconds: boolean = false, utc: boolean = false) => {
  if (date) {
    const seconds = includeSeconds ? ':ss' : '';
    const mDate = utc ? moment(date).utc() : moment(date);
    return mDate.format(`Do MMM YYYY HH:mm${seconds}`) + (utc ? ' (UTC)' : '');
  } else {
    return '';
  }
});

Vue.filter('formatShortDate', (date: Date | string | number, utc: boolean = false) => {
  if (date) {
    const mDate = utc ? moment(date).utc() : moment(date);
    return mDate.format('Do MMM YYYY') + (utc ? ' (UTC)' : '');
  } else {
    return '';
  }
});

Vue.filter('formatISODate', (date: Date | string | number, utc: boolean = false) => {
  if (date) {
    const mDate = utc ? moment(date).utc() : moment(date);
    return mDate.format('YYYY-MM-DD HH:mm:ss');
  } else {
    return '';
  }
});

Vue.filter('formatCSVDate', (date: Date | string | number, utc: boolean = false) => {
  if (date) {
    const mDate = utc ? moment(date).utc() : moment(date);
    return mDate.format('YYYY-MM-DD, h:mm:ss');
  } else {
    return '';
  }
});

Vue.filter('formatDateDiffHoursMinutes', (date: Date | string | number) => {
  if (date) {
    const then = moment(date);
    const now = moment();
    const duration = moment.duration(now.diff(then));
    const days = duration.days();
    const hours = duration.hours();

    return days + ' days ' + hours + ' hours ago';
  } else {
    return '';
  }
});

Vue.filter('formatDateDiffFull', (date: Date | string | number) => {
  if (!date) {
    return '';
  }

  const then = moment(date);
  const now = moment();
  const duration = moment.duration(now.diff(then));

  const timeParts = [
    { unit: 'year', value: duration.years() },
    { unit: 'month', value: duration.months() },
    { unit: 'day', value: duration.days() },
    { unit: 'hour', value: duration.hours() },
    { unit: 'minute', value: duration.minutes() },
  ];

  const nonZeroParts = timeParts.filter((part) => part.value > 0);

  if (nonZeroParts.length === 0) {
    return 'just now';
  }

  const partsToShow = nonZeroParts;

  const formattedParts = partsToShow.map((part) => {
    return `${part.value} ${part.unit}${part.value > 1 ? 's' : ''}`;
  });

  return `${formattedParts.join(', ')} ago`;
});

Vue.filter('formatDateDiff', (date: Date | string | number) => {
  if (date) {
    return moment(date).fromNow();
  } else {
    return '';
  }

});

Vue.filter('truncate', (text: string, maxLength: number) => {
  if (!text) {
    return null;
  }
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.substring(0, maxLength)}...`;
});

Vue.filter('replaceNewlineWithBreak', (text: string) => {
  if (!text) {
    return null;
  } else {
    return text.replace(/\n/g, `<br />`);
  }
});

Vue.filter('generateLuhnForIccid', generateLuhnForIccid);

Vue.filter('dialogWidthFromBreakpoint', (breakpointName: string) => {
  switch (breakpointName) {
    case 'xs':
      return '90vw';
    case 'sm':
      return '85vw';
    case 'md':
      return '80vw';
    case 'lg':
      return '75vw';
    case 'xl':
      return '70vw';
  }
});
